import { CsvOrderTemplateModelType } from '@teinor/erp/types/company/config/csvOrderTemplate'
import { dictionaryComplexFromJsonArr } from '../../globals/dictionary'

export interface CsvOrderTemplatesAction {
    type: 'CHANGE_CSV_ORDER_TEMPLATE'
    payload: CsvOrderTemplateModelType[]
}

export type CsvOrderTemplatePayload = { [id: string]: CsvOrderTemplateModelType } | null

export default function csvOrderTemplates(state: CsvOrderTemplatePayload = null, action: CsvOrderTemplatesAction): CsvOrderTemplatePayload {
    switch (action.type) {
        case 'CHANGE_CSV_ORDER_TEMPLATE':
            const csvOrderTemplates = dictionaryComplexFromJsonArr(action.payload || [])
            return state = csvOrderTemplates
        default:
            return state
    }
}